import { useEffect, useRef } from "react";
import { isChatContainerAtBottom } from "utils/chat";
import { useChatScrollContext } from "../components/Chat/ChatScrollContext";

export const useScrollToTarget = (
  dependency: string | null | undefined,
  isFirstRender: boolean
) => {
  const { shouldScroll, bottomRef, containerRef } = useChatScrollContext();

  const shouldScrollRef = useRef(shouldScroll);
  shouldScrollRef.current = shouldScroll;

  useEffect(() => {
    if (!shouldScrollRef.current) return;

    const scrollToTarget = () => {
      if (!shouldScrollRef.current) return;
      if (!bottomRef?.current) return;
      if (
        containerRef.current &&
        !isChatContainerAtBottom(containerRef.current.scrollTop, 10)
      )
        return;

      const behavior = isFirstRender ? "instant" : "smooth";

      requestAnimationFrame(() => {
        if (!shouldScrollRef.current) return;
        bottomRef.current?.scrollIntoView({
          behavior,
          block: "start",
        });
      });
    };

    scrollToTarget();

    const container = containerRef.current;
    if (!container) return;

    const observer = new ResizeObserver(() => {
      scrollToTarget();
    });

    observer.observe(container);

    const timeout = setTimeout(() => {
      observer.disconnect();
    }, 500);

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, [dependency]);
};
